import callsService from "../api/server/callsService";
export const CALLS_NAMESPACE = "callsModule";

var fakeService;
const loadFakeService = async () => {
  if (fakeService) return fakeService;
  return import(
    `../api/${process.env.VUE_APP_SERVICE_FOLDER}/callsService`
  ).then(x => {
    fakeService = x.default;
    return fakeService;
  });
};

var services = {
  api:
    (process.env.VUE_APP_SERVICE_FOLDER === "fakes" &&
      process.env.NODE_ENV === "development") ||
    process.env.NODE_ENV === "test"
      ? loadFakeService()
      : Promise.resolve(callsService)
};

const state = {
  broadcasting: false,
  packageIds: [],
  broadcastMessages: null
};
const actions = {
  async submitTrackingNumbers(context, data) {
    context.commit("SET_PACKAGE_IDS_LIST", []);
    var api = await services.api;
    return api.getPackageIds(data).then(response => {
      context.commit("SET_PACKAGE_IDS_LIST", response);
    });
  },
  async sendCallBroadcastData(context, data) {
    context.commit("SET_BROADCAST_MESSAGES", null);
    context.state.broadcasting = true;
    var api = await services.api;
    return api.sendCallBroadcast(data).then(response => {
      context.state.broadcasting = false;
      context.commit("SET_BROADCAST_MESSAGES", response);
    });
  }
};

const mutations = {
  SET_PACKAGE_IDS_LIST(storeState, data) {
    state.packageIds = data;
  },
  SET_BROADCAST_MESSAGES(storeState, data) {
    if (data) {
      var messageData = {};
      for (let key in data) {
        if (data[key].length > 0) {
          messageData[key] = [];
          data[key].forEach(packageId => {
            var packageTrackingNumber = storeState.packageIds.find(x => {
              return x.PackageId === packageId;
            });
            if (packageTrackingNumber)
              messageData[key].push(packageTrackingNumber.TrackingNumber);
          });
        }
      }
      storeState.broadcastMessages = {
        successfulMessage: messageData.SuccessfulPackageIds
          ? "Broadcast successful on tracking number(s): " +
            messageData.SuccessfulPackageIds.join(", ")
          : "",
        failedMessage: messageData.FailedPackageIds
          ? "Broadcast failed on tracking number(s): " +
            messageData.FailedPackageIds.join(", ")
          : ""
      };
    } else {
      storeState.broadcastMessages = null;
    }
  }
};

const getters = {
  broadcasting: storeState => storeState.broadcasting,
  packageIds: storeState => storeState.packageIds,
  broadcastMessages: storeState => storeState.broadcastMessages
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
  services
};
